import { render, staticRenderFns } from "./DonutChart06Template.vue?vue&type=template&id=17dc05de&scoped=true&"
import script from "./DonutChart06Template.vue?vue&type=script&lang=js&"
export * from "./DonutChart06Template.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17dc05de",
  null
  
)

export default component.exports